/* Queries */
import { sbRespDesignsRoot } from '../../queries/sbRespDesignsRoot.js';

/* Reducers */
import { defaultReducers, actionSanitizer } from '../../reducers/reducerUtils.js';
import { sbSharedReducers } from '../../reducers/sbSharedReducers.js';
import { sbRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/sbRespNotificationsReducer.js';

/* Components */
import { SbRespDesignsLayout } from '../../finding/SbRespDesignsLayout/SbRespDesignsLayout.tsx';

/* Helpers */
import { createEntry } from '../createEntry.jsx';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { datadog, initSharedDatadogRum, sbTypes } from 'dibs-datadog/exports/datadog.ts';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';
import SV from 'server-vars';
import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

/* Notifications */
import { sbRespNotifications } from '../../finding/SbRespNotifications/sbRespNotifications.js';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    notifications: sbRespNotifications,
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
        sharedNotificationsReducer,
    },
    state: SV.get('storeState'),
    actionSanitizer,
};

datadog.load().then(dd => {
    initSharedDatadogRum(dd, {
        page: PAGE_TYPE.BROWSE,
        device: 'resp',
        pageSubType: sbTypes.browse,
    });
    setDatadogABTestValues();
});

initializeDBL(options).then(({ store, queue, actions }) => {
    createEntry({
        Container: SbRespDesignsLayout,
        store,
        query: sbRespDesignsRoot,
        containerId: 'page',
        queue,
        actions,
    });
});
